const convertToDatetime = value => {
  try {
    return new Date(value).toISOString()
  } catch (error) {
    return null
  }
}

export default convertToDatetime



// WEBPACK FOOTER //
// ./src/utility/convertToDatetime.js